import type { RouteLocationRaw } from 'vue-router'
import type { NavSection } from '@utils/nav-section'

export interface NavDestination {
    id: NavSection
    label: string
    shortLabel?: string
    icon: string
    to: RouteLocationRaw
}

// The five destinations, in PRD order. Music = today's mixes catalog; Explore = the
// tabbed hub at the existing browse URLs (Genres · Charts · Playlists).
// Icons: FDS `browse` (record crate) and `explore` (SF globe).
export const NAV_DESTINATIONS: NavDestination[] = [
    { id: 'home', label: 'Home', icon: 'home', to: { name: 'home' } },
    { id: 'radio', label: 'Radio', icon: 'radio', to: { name: 'channel-index' } },
    { id: 'music', label: 'Music', icon: 'browse', to: { name: 'browse/mixes/latest' } },
    { id: 'explore', label: 'Explore', icon: 'explore', to: { name: 'browse/genres' } },
    { id: 'library', label: 'Library', icon: 'heart', to: { name: 'your-library' } },
]

// First-class row directly under Library for free/logged-out visitors (desktop amendment
// 2026-09-09); attribution `from: sidebar` must survive (view-plans.vue maps it).
export const PREMIUM_DESTINATION: NavDestination = {
    id: 'premium',
    label: 'Go Premium',
    shortLabel: 'Premium',
    icon: 'logo-premium-mark',
    to: { name: 'premium/view-plans', query: { from: 'sidebar' } },
}

export const SEARCH_DESTINATION: NavDestination = {
    id: 'search',
    label: 'Search',
    icon: 'search',
    to: { name: 'search' },
}

function byId(id: NavSection): NavDestination {
    const destination = NAV_DESTINATIONS.find(candidate => candidate.id === id)
    if (!destination) throw new Error(`No nav destination with id "${id}"`)
    return destination
}

// Phone tab set (phone amendment 2026-09-10): Explore and Music have no tab — both fold
// into Home (navSectionFor's PHONE_FOLD).
export const PHONE_TABS: NavDestination[] = [byId('home'), byId('radio'), SEARCH_DESTINATION, byId('library')]

// Last tab for free / logged-out visitors, hidden for subscribers; attribution `from: tab-bar`
// (view-plans.vue maps it to ENTRY_POINTS.TAB_BAR). The label is already short, so no shortLabel.
export const PHONE_PREMIUM_TAB: NavDestination = {
    id: PREMIUM_DESTINATION.id,
    label: 'Premium',
    icon: PREMIUM_DESTINATION.icon,
    to: { name: 'premium/view-plans', query: { from: 'tab-bar' } },
}
